export enum URLEnum {
    COMMAND = 'Command',
    OPERATION = 'Operation',
}

export enum GetUrlEnum {
    DMINFO = 'DmInfo',
    PATTERN_CREATION = 'PatternCreation',
}
